<template>
  <div class="form-group event-form-group1">
    <label>ご希望の開催日をご選択ください</label>
    <ul class="checkblock-list">
      <li
        v-for="dateItem in dateList"
        :key="dateItem.id"
        class="checkblock-list-item"
      >
        <div
          class="checkblock"
          :class="classNames(dateItem)"
          @click="$emit('input', startTimeProp(dateItem, 'event_id'))"
        >
          <input
            type="checkbox"
            :value="startTimeProp(dateItem, 'event_id')"
            :disabled="isUnavailable(dateItem)"
          />
          <div class="checkblock-label">
            <div class="space-between">
              <div class="text-paragraph">
                <p
                  v-if="dateItem.event_description"
                  v-html="$domUtils.nl2br(dateItem.event_description)"
                  class="text-primary text-bold text-xxs"
                />
                <p>{{ dateItem.date | formatDateWeekDay }}</p>
                <p>{{ startTimeProp(dateItem, 'start_time') | formatTime }}</p>
              </div>
              <p class="text-danger text-xxxs">
                残り{{ startTimeProp(dateItem, 'available_sets') }}組様
              </p>
            </div>
          </div>
          <span class="checkblock-toggle" />
        </div>
      </li>
    </ul>
    <FormError :errors="error"/>
  </div>
</template>

<script>
import FormError from '@/components/FormError.vue'
import { formatDateWeekDay } from '@/filters/format-date'
import formatTime from '@/filters/format-time'

export default {
  props: {
    dateList: {
      type: Array,
      required: true,
    },
    value: {
      type: Number,
      required: true,
    },
    error: {
      type: Array,
      required: true,
    }
  },

  components: {
    FormError
  },

  filters: {
    formatDateWeekDay,
    formatTime,
  },

  methods: {
    classNames(dateItem) {
      return {
        'is-checked': this.isChecked(dateItem),
        'is-disabled': this.isUnavailable(dateItem),
      }
    },
    isUnavailable(dateItem) {
      return this.startTimeProp(dateItem, 'available_sets') === 0
    },
    isChecked(dateItem) {
      return this.value === dateItem.start_time_list[0].event_id
    },
    startTimeProp(dateItem, key) {
      return dateItem.start_time_list[0][key]
    }
  }
}
</script>
